import type { MaskKind } from "../types/TestTarget";

/** 一覧表示用ラベル（名称変更時はこのファイルのみ修正） */
export const MASK_TYPE_NONE_LIST_LABEL = "なし";

export const MASK_KIND_DISPLAY_LABELS: Record<MaskKind, string> = {
  cover: "cover",
  hide: "hide",
  remove: "remove",
};

/** 項目一覧の「マスク種別」列。未設定・無効値は「なし」。 */
export function formatMaskTypeForList(params: unknown): string {
  if (!params || typeof params !== "object") {
    return MASK_TYPE_NONE_LIST_LABEL;
  }
  const maskType = (params as { maskType?: unknown }).maskType;
  if (
    maskType === "cover" ||
    maskType === "hide" ||
    maskType === "remove"
  ) {
    return MASK_KIND_DISPLAY_LABELS[maskType];
  }
  return MASK_TYPE_NONE_LIST_LABEL;
}

const REGRESSION_TAG = "regression";

/**
 * マスク設定を保存用に正規化する。
 * maskType が設定されていれば maskTags は常に ["regression"] に固定する。
 * 未設定なら明示的 null クリア信号を返す（API 側のマージロジックが null を
 * キー削除として解釈するため、既存マスク設定の残留を防ぐ）。
 */
export function normalizeMaskSettings(
  maskType: MaskKind | ""
): { maskType: MaskKind | null; maskTags: string[] | null } {
  if (!maskType) {
    return { maskType: null, maskTags: null };
  }
  return { maskType, maskTags: [REGRESSION_TAG] };
}
